
<template>
  <!-- 季度选择时间控件 -->
  <div class="year-picker">
    <el-date-picker
      v-model="beginTime"
      type="week"
      align="right"
      :format="formatMoment(beginTime)"
      :picker-options="isInterval?beginPickerOptions:pickerOptionsWeek"
      :clearable="false"
      style="width: 160px;"
      @change="changeTime"
      prefix-icon="icon icon-calendar"
      :placeholder="$t('components_weekRangePicker.kai_shi_zhou')">
    </el-date-picker>
    -
    <el-date-picker
      v-model="endTime"
      type="week"
      align="right"
      :format="formatMoment(endTime)"
       :picker-options="isInterval?endPickerOptions:pickerOptionsWeek"
      :clearable="false"
      style="width: 160px;"
      @change="changeTime"
      prefix-icon="icon icon-calendar"
      :placeholder="$t('components_weekRangePicker.jie_shu_zhou')">
    </el-date-picker>
  </div>
</template>
<script>
import moment from 'moment';
/**
 * @file:  View 组件 周选择控件
 * @description: UI组件  可选择周
 * @api: value : 周value defalut['前11周', '当前周'] 默认值待设置
 * 代码中注释部分是组件原默认时间配置，我这里做了更改，但是原设置可以参考
 */
export default {
  name: 'WeekRangpicker',
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    isInterval: {
      type: Boolean,
      default() {
        return false;
      }
    },
    disableFuture: {
      type: Boolean,
      default() {
        return true;
      }
    },
  },
  data() {
    return {
      beginTime: this.value[0],
      endTime: this.value[1],

      beginPickerOptions: {
        firstDayOfWeek: 1,
        disabledDate: (date) => {
          const now = new Date();
          // 禁用未来日期
          if (this.disableFuture && date > now) {
            return true;
          }

          // 禁用2016年之前的日期
          const minYearLimit = moment('2015-12-28 00:00:00').valueOf();
          if (moment(date).valueOf() < minYearLimit) {
            return true;
          }

          // 当结束时间存在时，开始时间不能早于（结束时间 - 1年）
          if (this.endTime) {
            const minDate = moment(this.endTime).subtract(1, 'years');
            return date < minDate.startOf('week').toDate();
          }
          return false;
        }
      },
      endPickerOptions: {
        firstDayOfWeek: 1,
        disabledDate: (date) => {
          const now = new Date();
          // 禁用未来日期
          if (this.disableFuture && date > now) {
            return true;
          }

          // 禁用2016年之前的日期
          const minYearLimit = moment('2015-12-28 00:00:00').valueOf();
          if (moment(date).valueOf() < minYearLimit) {
            return true;
          }

          // 当开始时间存在时，结束时间不能晚于（开始时间 + 1年）
          if (this.beginTime) {
            const beginMoment = moment(this.beginTime);

            // 计算允许的最小日期和最大日期
            const minDate = beginMoment.clone().subtract(1, 'years').startOf('day');
            const maxDate = beginMoment.clone().add(1, 'years').endOf('week');

            // 如果日期早于 minDate 或晚于 maxDate，则禁用
            if (moment(date).isBefore(minDate) || moment(date).isAfter(maxDate)) {
              return true;
            }
          }

          return false;
        }
      },
      pickerOptionsWeek: {
        firstDayOfWeek: 1,
        disabledDate: time => {
          // 禁用2016年之前的日期
          const minYearLimit = moment('2015-12-28 00:00:00').valueOf();
          if (moment(time).valueOf() < minYearLimit) {
            return true;
          }
          return this.disableFuture ? time > new Date() : false;
        }
      },
    };
  },

  mounted() {
    this.beginTime = this.value[0];
    this.endTime = this.value[1];
  },
  watch: {
    value: function (val) {
      this.beginTime = val[0];
      this.endTime = val[1];
    }
  },
  methods: {
    formatMoment(time) {
      // moment.updateLocale('en', { week: {
      //   // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
      //   dow: 1, // Monday is the first day of the week.
      //   doy: 7 // The week that contains Jan 4th is the first week of the year.// 年份的第一周必须包含1月1日 (7 + 1 - 1)
      // } });
      // 设置周的开始时间是星期一 1月1号是年开始的第一周
      moment.updateLocale('en', {
        week: {
          // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
          dow: 1, // Monday is the first day of the week.
          doy: 7, // The week that contains Jan 4th is the first week of the year.// 年份的第一周必须包含1月1日 (7 + 1 - 1)
        },
      });
      const YYYY = moment(time).endOf('week').format('YYYY');
      const w = moment(time).endOf('week').format('w');
      const tips = this.$t('components_weekRangePicker.odiozhou', [YYYY,w]);
      return tips;
      // return moment(time).endOf('week').format(tpl);
    },
    changeTime() {
      // 确保 beginTime 是较小的时间，endTime 是较大的时间
      if (moment(this.beginTime).isAfter(moment(this.endTime))) {
        const temp = this.beginTime;
        this.beginTime = this.endTime;
        this.endTime = temp;
      }
      // 将时间转换为 moment 对象并传递出去
      const Timer = [moment(this.beginTime), moment(this.endTime)];
      this.$emit('input', Timer);
      this.$emit('change', Timer);
    },

  }
};
</script>

<style lang="scss">
.quarter-picker {
  display: inline;
  .firstBtn {
    height: 30px;
    line-height: 34px;
    width: 100%;
    text-align: center;
  }
  .text {
    text-align: center;
    margin: 15px 0 10px;
  }
  .item {
    text-align: center;
  }
}
.colorDis {
  color: #999 !important;
}
.quarter-picker {
  .el-card__header {
    padding: 12px;
  }
}
</style>
